module.exports = __webpack_public_path__ + "2a80dccddeb529b75a8d7ec42fd46596.pdf";